declare const KUSTOMER_ENV: string

export interface KustomerConfig {
  apiKey: string
  brandId: string
  assistantId: string
  scheduleId: string
  lang?: string
}

export interface AppConfig extends KustomerConfig {
  liveHelpText: string
}

export function getConfigForLocale(locale: string): AppConfig | undefined {
  const kustomerConfig = getConfig();

  if (!kustomerConfig.hasOwnProperty(locale))
    return undefined

  const config = kustomerConfig[locale]
  config.lang = locale.split('-')[0]
  return config
}

function getConfig(): { [key: string]: AppConfig } {
  let kustomerConfig: { [key: string]: KustomerConfig }

  if (KUSTOMER_ENV === 'prod') {
    kustomerConfig = require('./ChatConfigProd').kustomerConfig
  }
  else {
    console.log('[kustomer-chat] KUSTOMER_ENV', KUSTOMER_ENV)
    console.log('[kustomer-chat] Working with Kustomer sandbox keys.')
    kustomerConfig = require('./ChatConfigSandbox').kustomerConfig
  }

  const config: { [key: string]: AppConfig } = {
    'en-US': {
      ...kustomerConfig.US,
      liveHelpText: 'For Live Help, please click the [chat-icon] icon in the lower right corner'
    },
    'es-US': {
      ...kustomerConfig.US,
      liveHelpText: 'Para obtener Ayuda en Vivo, favor de hacer clic en el [chat-icon] icono de la parte inferior derecha'
    },
    'en-CA': {
      ...kustomerConfig.CA,
      liveHelpText: 'For Live Help, please click the [chat-icon] icon in the lower right corner'
    },
    'fr-CA': {
      ...kustomerConfig.CA,
      liveHelpText: "Pour l'aide en direct, veuillez cliquer sur [chat-icon] l'icône en bas à droite"
    },
  }

  return config
}

